var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center mb-4 divider-wrapper"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.sectionTitle))]),_c('div',{staticClass:"divider"})])}
var staticRenderFns = []

export { render, staticRenderFns }